import * as React from "react";
export default function LazyComponent(load) {
    let mod;
    return (props) => {
        if (mod === undefined) {
            mod = load();
        }
        return React.createElement(mod.default, { ...props });
    };
}
